import PayDevice from './PayDevice'
export default PayDevice
